import { render, staticRenderFns } from "./blockedSenders.vue?vue&type=template&id=f09f14c8&scoped=true&"
import script from "./blockedSenders.vue?vue&type=script&lang=js&"
export * from "./blockedSenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09f14c8",
  null
  
)

export default component.exports